import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { _AbcFormComponent, AbcIconComponent } from '@barthauer/abc/ui-components';
import { DxFormModule, DxTextBoxModule, DxButtonComponent } from 'devextreme-angular';
import { ContextService } from './services/context.service';
import { DataService } from './services/data.service';
import { UserSettingsComponent } from './user-settings.component';

@NgModule({
  imports: [CommonModule, DxFormModule, _AbcFormComponent, DxTextBoxModule, AbcIconComponent],
  declarations: [UserSettingsComponent],
  exports: [UserSettingsComponent],
  providers: [ContextService, DataService],
})
export class UsersModule {}
